import api from '@/api/api'
import router from '@/router/index'
export default {
  namespaced: true,
  state: {
    componenteSeleccionado: '',
    societies: [],
    promotions: [],
    promotionsProvider: [],
    imageByPromo: [],
    imageByProperty: [],
    customers: [],
    customersByPromo: [],
    providers: [],
    operations: [],
    ambitsOperation: [],
    properties: [],
    propertyTypes: [],
    promotionIdByProperty: null,
    checkProviderHasPromotions: false,
    actorsProvider: [],
    promotionsActor: []
  },
  mutations: {
    setComponenteSeleccionado (state, payload) {
      state.componenteSeleccionado = payload
    },
    setSocieties (state, payload) {
      state.societies = payload
    },
    setCustomers (state, payload) {
      state.customers = payload
    },
    setCustomersByPromo (state, payload) {
      state.customersByPromo = payload
    },
    setProviders (state, payload) {
      state.providers = payload
    },
    setOperations (state, payload) {
      state.operations = payload
    },
    setAmbitsOperation(state, payload) {
      state.ambitsOperation = payload
    },
    setProperties(state, payload) {
    state.properties = payload
    },
    setPromotions(state, payload) {
      state.promotions = payload
    },
    setPromotionsProvider(state, payload) {
      state.promotionsProvider = payload
    },
    setCheckProviderHasPromotions(state, payload) {
      state.checkProviderHasPromotions = payload
    },
    setImageByPromo(state, payload)
    {
      state.imageByPromo = payload
    },
    setImageByProperty(state, payload)
    {
      state.imageByProperty = payload
    },
    setPropertyTypes (state, payload) {
      state.propertyTypes = payload
    },
    setActorsProvider (state, payload) {
      state.actorsProvider = payload
    },
    setPromotionByPropertyId (state, payload) {
      state.promotionIdByProperty = payload
    },
    setPromotionSelected(state, payload) {
      state.promotionsProvider.find (promotion => {
        if (promotion.id === payload.id) {
          promotion.selected = payload.selected
        }
      })
    },
    setPromotionsActor (state, payload) {
      state.promotionsActor = payload
    },
  },
  actions: {
    getRootState({rootState})
    {
      return rootState.login.credentials
    },
    getComponenteSeleccionado ({commit}, values) {
      console.log('entro a la store', values);
      commit('setComponenteSeleccionado', values)
    },
    // controladores sociedades
    obtenerSociedades ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('society/getSocieties', {
          credentials: rootState.login.credentials,
          values: {}
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setSocieties', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })   
    },
    addSociety ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('society/addSocieties', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateSociety ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        
        api.post('society/updateSocieties', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    
    deleteSocieties ({ rootState, dispatch }, societyId) {
      
      return new Promise((resolve, reject) => {
        api.post('society/delSocieties', {
          credentials: rootState.login.credentials,
          values: {
            id: societyId
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    //controladores de promociones

    getPromotions ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {api.post('promotion/getPromotions', {
        credentials: rootState.login.credentials,
        values: {}
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setPromotions', response.data.data)
          resolve()
        })
        .catch(e => {
          reject(e)
        })
      })
    },

    setPromotionsProvider ({commit}, promociones) {
      commit('setPromotionsProvider', promociones)
    },
    setCheckProviderHasPromotions ({commit}, promociones) {
      commit('setCheckProviderHasPromotions', promociones)
    },
    
    getPromotionsProvider ({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {api.post('promotion/getPromotionsProvider', {
        credentials: rootState.login.credentials,
        values
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setPromotionsProvider', response.data.data)
          resolve()
        })
        .catch(e => {
          reject(e)
        })
      })
    },
    
    checkProviderHasPromotions ({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {api.post('promotion/checkProviderHasPromotions', {
        credentials: rootState.login.credentials,
        values
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          if ( response.data.data.length > 0 ) {
            commit('setCheckProviderHasPromotions', true)
          }
          else {
            commit('setCheckProviderHasPromotions', false)
          } 
          resolve()
        })
        .catch(e => {
          reject(e)
        })
      })
    },

    getImageByPromo({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {api.post('promotion/getImageByPromo', {
        credentials: rootState.login.credentials,
        values
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          commit('setImageByPromo', response.data.data)
          resolve()
        })
        .catch(e => {
          reject(e)
        })
      })
    },

    addPromotion ({ rootState, dispatch }, values) {
  
      return new Promise((resolve, reject) => {
        api.post('promotion/addPromotion', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    
    deletePromotion ({ rootState, dispatch }, values) {
      console.log('entro en ver que envio al borrar', values.id, values.code);
      return new Promise((resolve, reject) => {
        api.post('promotion/delPromotion', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    updatePromotion ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('promotion/updatePromotion', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    //controladores de proveedores
    getProviders ({commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('provider/getProvidersAllInfo', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setProviders', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },

    addProvider ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('provider/addProvidersAllInfo', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    deleteProvider ({ rootState, dispatch }, providerId) {
      return new Promise((resolve, reject) => {
        api.post('provider/delProviders', {
          credentials: rootState.login.credentials,
          values: {
            id: providerId
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    updateProvider ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('provider/updateProvidersAllInfo', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    
    //controladores de inmuebles

    getInmuebles ({commit, rootState, dispatch }) {
      const idubapi = rootState.login.idubapi
      const promociones = {
        [idubapi.idubapi]: idubapi.promociones
      }
      return new Promise((resolve, reject) => {
        api.post('property/getProperties', {
          credentials: rootState.login.credentials,
          promociones: promociones
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setProperties', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getImageByProperty({ commit, rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {api.post('property/getImageByProperty', {
        credentials: rootState.login.credentials,
        values
      })
        .then(response => {
          if (response.data.data && response.data.data.mensajeSesion) {
            dispatch('alerts/addNotLoggedIn', null, { root: true })
            router.push({ name: 'login' })
            return
          }
          console.log(response, 'esta es la response');
          commit('setImageByProperty', response.data.data)
          resolve()
        })
        .catch(e => {
          reject(e)
        })
      })
    },
    addProperty ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('property/addProperty', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    updateProperty ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('property/updateProperty', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    deleteProperty ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('property/delProperty', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    //controladores de operaciones

    getOperaciones ({commit, rootState, dispatch }) {
      const idubapi = rootState.login.idubapi
      const promociones = {
        [idubapi.idubapi]: idubapi.promociones
      }
      return new Promise((resolve, reject) => {
        api.post('operation/getOperations', {
          credentials: rootState.login.credentials,
          promociones: promociones
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setOperations', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    codigoUsado({ rootState, dispatch }, values){
      return new Promise((resolve, reject) => {
        api.post('operation/codigoUsado', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return 
            }
            resolve(response.data.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    checkOperationPropertyUsed({/* commit, */ rootState, dispatch }, values){
      return new Promise((resolve, reject) => {
        api.post('operation/checkOperationPropertyUsed', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return 
            }
            resolve(response.data.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },

    checkOperationsWillBeDeleted({rootState, dispatch }, values){
      return new Promise((resolve, reject) => {
        api.post('operation/checkOperationsWillBeDeleted', {
          credentials: rootState.login.credentials,
          values
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return 
            }
            resolve(response.data.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    getAmbitosOperacion ({commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('operation/getAmbitsOperation', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setAmbitsOperation', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    }, 
    addOperation ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('operation/addOperation', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateOperation ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('operation/updateOperation', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    deleteOperation ({ rootState, dispatch }, operationCode) {
      return new Promise((resolve, reject) => {
        api.post('operation/delOperation', {
          credentials: rootState.login.credentials,
          values: {
            code: operationCode
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    delOperationIdsArray ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('operation/delOperationIdsArray', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    
    //controladores de clientes
    getClientes ({commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        api.post('customer/getCustomers', {
          credentials: rootState.login.credentials
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setCustomers', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },

    getClientesPorPromo ({commit, rootState, dispatch }, value) {
      return new Promise((resolve, reject) => {
        api.post('customer/getCustomerByPromo', {
          credentials: rootState.login.credentials,
          value
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject(response.data)
              return
            }
            commit('setCustomersByPromo', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    addClient ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('customer/addCustomer', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateClient ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('customer/updateCustomer', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },

    deleteClient ({ rootState, dispatch }, customerId) {
     
      return new Promise((resolve, reject) => {
        api.post('customer/delCustomer', {
          credentials: rootState.login.credentials,
          values: {
            id: customerId
          }
        }).then(response => {
          if (response.data.result === 'OK') {
           
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    // controladores de tiposInmueble

    getPropertyTypes ({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
          api.post('propertyType/getPropertyTypes', {
          credentials: rootState.login.credentials,
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setPropertyTypes', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })  
    },
    getActorsProvider ({ commit, rootState, dispatch }, providerId) {
      return new Promise((resolve, reject) => {
          api.post('actor/getActoresProveedor', {
          credentials: rootState.login.credentials,
          values: {
            proveedorId: providerId
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setActorsProvider', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })  
    },
    
    getPromotionsByActor ({ commit, rootState, dispatch }, { id_actor, id_proveedor }) {
      const idubapi = rootState.login.idubapi

      return new Promise((resolve, reject) => {
          api.post('promotion/getPromotionsByActor', {
          credentials: rootState.login.credentials,
          values: {
            actorId: id_actor,
            proveedorId: id_proveedor,
            promociones: idubapi.promociones
          }
        })
          .then(response => {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              return
            }
            commit('setPromotionsActor', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
          })
      })  
    },

    addPropertyType ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('propertyType/addPropertyTypes', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updatePropertyType ({ rootState, dispatch }, values) {
      return new Promise((resolve, reject) => {
        api.post('propertyType/updatePropertyTypes', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    deletePropertyType ({ rootState, dispatch }, propertyTypeId) {
      return new Promise((resolve, reject) => {
        api.post('propertyType/delPropertyTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: propertyTypeId
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    //controladores de tiposVisita
    addVisitType ({ rootState, dispatch }, values)
    {
      return new Promise((resolve, reject) => {
        api.post('visitType/addVisitTypes', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateVisitType ({ rootState, dispatch }, values) {
     
      return new Promise((resolve, reject) => {
        api.post('visitType/updateVisitTypes', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    deleteVisitType ({ rootState, dispatch }, visitTypeId) {
      
      return new Promise((resolve, reject) => {
        api.post('visitType/delVisitTypes', {
          credentials: rootState.login.credentials,
          values: {
            id: visitTypeId
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
   
    addUrgencia ({ rootState, dispatch }, values){
      
      return new Promise((resolve, reject) => {
        api.post('urgency/addUrgency', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    updateUrgencia ({ rootState, dispatch }, values) {
      
      return new Promise((resolve, reject) => {
        api.post('urgency/updateUrgency', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    delUrgencia ({ rootState, dispatch }, urgenciaId) {
     
      return new Promise((resolve, reject) => {
        api.post('urgency/delUrgency', {
          credentials: rootState.login.credentials,
          values: {
            id: urgenciaId
          }
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    realizarImportacionSociedades ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('society/importarSociedades', {
          credentials: credenciales,
          values
        })
          .then(response => {
            console.log(response)
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },   
    realizarImportacionTiposInmueble ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('propertyType/importarTiposInmueble', {
          credentials: credenciales,
          values
        })
          .then(response => {
            console.log(response)
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    realizarImportacionClientes ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('customer/importarClientes', {
          credentials: credenciales,
          values
        })
          .then(response => {
            console.log(response)
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }, 
    
    realizarImportacionPromociones ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('promotion/importarPromociones', {
          credentials: credenciales,
          values
        })
          .then(response => {
            console.log(response)
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },

    realizarImportacionInmuebles ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('property/importarInmuebles', {
          credentials: credenciales,
          values
        })
          .then(response => {
            console.log(response)
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    
    realizarImportacionOperaciones ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('operation/importarOperaciones', {
          credentials: credenciales,
          values
        })
          .then(response => {
            console.log(response)
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    
    realizarImportacionProveedores ({dispatch, rootState}, values) {
      return new Promise((resolve, reject) => {
        const credenciales = rootState.login.credentials
        const idubapi = rootState.login.idubapi
        const promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
        credenciales.promociones = promociones
        api.post('provider/importarProveedores', {
          credentials: credenciales,
          values
        })
          .then(response => {
            console.log(response)
            if (response.data.result === 'OK') {
              resolve(response.data)
            } else {
              if (response.data.data && response.data.data.mensajeSesion) {
                dispatch('alerts/addNotLoggedIn', null, { root: true })
                router.push({ name: 'login' })
                reject({
                  message: response.data.data.mensajeSesion
                })
                return
              }
              // eslint-disable-next-line
              reject({
                message: response.data.descriptionNOK.replace('<br><br>', '')
              })
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    updateProviderActorPromotion ({ rootState, dispatch }, values) {
      const idubapi = rootState.login.idubapi
      values.promocionesActor = idubapi.promociones
      
      return new Promise((resolve, reject) => {
        api.post('Provider/updateProviderActorPromotion', {
          credentials: rootState.login.credentials,
          values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response)
          } else {
            if (response.data.data && response.data.data.mensajeSesion) {
              dispatch('alerts/addNotLoggedIn', null, { root: true })
              router.push({ name: 'login' })
              reject({
                message: response.data.data.mensajeSesion
              })
              return
            }
            // eslint-disable-next-line
            reject({
              message: response.data.descriptionNOK.replace('<br><br>', '')
            })
          }
        })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
},
  getters: {
    /* getSociedades (state) {
      return state.sociedades
    } */
    getPromotionsProvider (state) {
      return state.promotionsProvider
    }
  }
}